<template>
  <div>
    <basic-container>
      <el-form ref="form" :model="projectDynamicForm">
        <el-form-item label="工程项目名称">
          <div style="display: flex;width:300px;">
            <el-select v-model="projectDynamicForm.projectItem" placeholder="请选择工程项目名称" width="200" disabled>
              <el-option v-for="item in projectItems" :key="item.id" :label="item.name" :value='item.id'></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="工程动态表单">
          <div v-for="(item, index) of dataList" :key="index">
            <el-table :data="item" :span-method="objectSpanMethod" :show-header='true' border
              style="width: 100%; margin-top: 20px">
              <el-table-column prop="clientType" label="预约渠道" align="center" min-width="180">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.clientType" placeholder="请选择服务类目名称" width="300" disabled>
                    <el-option v-for="item in clientTypes" :key="item.value" :label="item.label"
                      :value='item.value'></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="projectList" align="center" label="字段名称" min-width="900">
                <template slot-scope="scope">
                  <div v-for="(i, idx) in dataList[index][0].projectList" v-bind:key='idx'>
                    <el-table :data="dataList[index][0].projectList[idx][0].dynamics" :span-method="inSpanMethod" border
                      style="width: 100%; margin-top: 20px">
                      <el-table-column prop="name" label="工程阶段名称" width="120">
                        <template slot-scope="scope">
                          {{ i[0].name }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="fieldName" label="显示名称">
                        <template slot-scope="scope">
                          <el-input type="input" name="fieldName" v-model="scope.row.fieldName"
                            :value="scope.row.fieldName" placeholder="请输入名称"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="inputType" min-width="150" label="控件类型">
                        <template slot-scope="scope">
                          <el-select name="inputType" v-model="scope.row.inputType" placeholder="请选择控件类型"
                            :value="scope.row.inputType">
                            <el-option v-for="item in inputTypes" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column prop="dataSource" min-width="150" label="数据源">
                        <template slot-scope="scope">
                          <el-select name="dataSource" v-model="scope.row.dataSource" placeholder="请选择数据源" clearable
                            :value="scope.row.dataSource">
                            <el-option v-for="item in dataSources" :key="item.id" :label="item.valueName"
                              :value="item.id">
                            </el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column prop="isNull" label="是否为空" width="150">
                        <template slot-scope="scope">
                          <el-radio v-model="scope.row.isNull" label="YES">是</el-radio>
                          <el-radio v-model="scope.row.isNull" label="NO">否</el-radio>
                        </template>
                      </el-table-column>
                      <el-table-column prop="isPay" label="是否计费" width="150">
                        <template slot-scope="scope">
                          <el-radio v-model="scope.row.isPay" label="YES">是</el-radio>
                          <el-radio v-model="scope.row.isPay" label="NO">否</el-radio>
                        </template>
                      </el-table-column>
                      <el-table-column prop="amount" label="计费金额">
                        <template slot-scope="scope">
                          <el-input type="input" name="amount" v-model="scope.row.amount"
                            :value="scope.row.amount"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="sort" label="排序">
                        <template slot-scope="scope">
                          <el-input type="input" name="sort" v-model="scope.row.sort"
                            :value="scope.row.sort"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="example" label="示例图片" width="200">
                        <template slot-scope="scope">
                          <image-upload :action="uploadUrl" :inTable="true" :multiple="true" :example="scope.row.example" :uploaded-images="scope.row.example"
                            @uploaded="(example) => handleUploaded(example, index, idx, scope.$index)"></image-upload>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" label="操作" width="150">
                        <template slot-scope="scope">
                          <el-button type="danger" icon="el-icon-close" size="small"
                            @click="handleSteppingDelete(index, idx, scope.$index)">删除</el-button>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" label="配置" width="150">
                        <template slot-scope="scope">
                          <el-button type="warning" icon="el-icon-check" size="small"
                            @click="handleAddRows(index, idx)">增加一行</el-button>
                        </template>
                      </el-table-column>
                      <template slot="empty">
                        <el-button type="warning" icon="el-icon-check" size="small" style="margin: 20px 0"
                          @click="handleAddRows(index, idx)">增加一行</el-button>
                      </template>
                    </el-table>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
      <div style='width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px'>
        <el-button type="primary" size="small" @click="submit">确定修改</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { DIC } from "@/const/dic";
import { resolveUrlPath } from "@/util/util";
import {
  findEngineeringProjectAll,
  findEngineeringDynamicDetail,
  findDataSourceAll,
  findDataSourceFields,
  editEngineeringDynamic
} from "@/api/work/projectDynamic";
export default {
  data() {
    return {
      projectItems: [],
      projectDynamicForm: {},
      dataList: [],
      clientTypes: DIC.SERVICEITEM_TYPE,
      dataSources: [],
      inputTypes: [],
      isPas: false,
      uploadUrl: '#', // 上传图片的接口地址
    };
  },
  created() {
    this.projectDynamicForm.projectItem = this.$router.currentRoute.query.id;
    findEngineeringDynamicDetail(this.$router.currentRoute.query.id).then(
      res => {
        let data = JSON.parse(res.data);
        let dataList = [];
        for (let i = 0; i < data.projectChannelList.length; i++) {
          let arr = [];
          let obj = {};
          obj.id = data.projectChannelList[i].id;
          obj.clientType = data.projectChannelList[i].clientType;

          let inDataList = [];
          for (
            let j = 0;
            j < data.projectChannelList[i].projectList.length;
            j++
          ) {
            let inarr = [];
            let inobj = {};
            inobj.id = data.projectChannelList[i].projectList[j].id;
            inobj.name = data.projectChannelList[i].projectList[j].name;
            inobj.dynamics = data.projectChannelList[i].projectList[j].dynamics;
            inarr.push(inobj);
            inDataList.push(inarr);
            for (
              let k = 0;
              k < data.projectChannelList[i].projectList[j].dynamics.length;
              k++
            ) {
              data.projectChannelList[i].projectList[j].dynamics[k].inputType =
                data.projectChannelList[i].projectList[j].dynamics[k]
                  .inputType + "";
              // 初始化 example 字段
              data.projectChannelList[i].projectList[j].dynamics[k].example = data.projectChannelList[i].projectList[j].dynamics[k].example || "";
            }
          }
          obj.projectList = inDataList;
          arr.push(obj);
          dataList.push(arr);
        }
        this.dataList = dataList;
      }
    );
    findDataSourceFields().then(res => {
      let data = JSON.parse(res.data);
      this.inputTypes = data;
    });
    findDataSourceAll().then(res => {
      let data = JSON.parse(res.data);
      this.dataSources = data.rows;
    });
    findEngineeringProjectAll().then(res => {
      let data = JSON.parse(res.data);
      this.projectItems = data;
    });
  },
  methods: {
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    inSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    handleAddRows(index, idx) {
      let obj = {};
      obj.fieldName = "";
      obj.inputType = "";
      obj.dataSource = "";
      obj.isNull = "";
      obj.isPay = "";
      obj.amount = "";
      obj.sort = "";
      obj.example = ''; // 初始化 example 字段
      this.dataList[index][0].projectList[idx][0].dynamics.push(obj);
    },
    handleSteppingDelete(index, idx, $index) {
      this.dataList[index][0].projectList[idx][0].dynamics.splice($index, 1);
    },
    handleUploaded(example, index, idx, $index) {
      this.dataList[index][0].projectList[idx][0].dynamics[$index].example = example;
    },
    submit() {
      let item = {
        close: true,
        label: "编辑工程动态表单",
        value: "/work/projectDynamic/edit"
      };
      let params = {};
      params.projectId = this.projectDynamicForm.projectItem;
      let projectChannelList = [];
      for (let i of this.dataList) {
        let obj = {};
        obj.id = i[0].id;
        obj.clientType = i[0].clientType;
        let projectList = [];
        for (let j = 0; j < i[0].projectList.length; j++) {
          projectList.push(i[0].projectList[j][0]);
        }
        obj.projectList = projectList;
        projectChannelList.push(obj);
      }
      params.projectChannelList = projectChannelList;
      editEngineeringDynamic(params).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "编辑成功",
            type: "success"
          });
          if (!this.isPas) {
            this.$store.commit("DEL_TAG", item);
            let obj = {
              value: "/work/projectDynamic",
              label: "工程动态表单管理"
            };
            this.$router.push({
              path: resolveUrlPath(obj.value, obj.label),
              query: obj.query
            });
            this.isPas = true;
          }
        } else {
          if (!this.isPas) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
            this.isPas = true;
            setTimeout(() => {
              this.isPas = false;
            }, 1000);
          }
        }
      });
    },
  }
};
</script>
